import { UseDigitalWalkInAvailabilityResult } from './useDigitalWalkInAvailability';

export function useShouldShowDigitalWalkIn(
    digitalWalkInSlots: UseDigitalWalkInAvailabilityResult,
    hasModal: boolean,
    isToday: boolean,
    availableSlots: number,
    hasSelectedProvider: boolean,
): boolean {
    if (
        digitalWalkInSlots.loading ||
        digitalWalkInSlots.error ||
        !digitalWalkInSlots.data ||
        !hasModal
    ) {
        return false;
    }

    // only works for the current day
    if (!isToday) {
        return false;
    }

    // hide if not enabled for this clinic
    if (!digitalWalkInSlots.data.available) {
        return false;
    }

    // hide if there are more than 3 available slots
    if (availableSlots > digitalWalkInSlots.data.maxAvailableTimeSlots) {
        return false;
    }

    // only show if "first available provider" is selected
    if (hasSelectedProvider) {
        return false;
    }

    // hide if we already had too many walk-ins for this clinic today
    if (!digitalWalkInSlots.data.maxAvailableTimeSlots) {
        return false;
    }

    return true;
}
